const SKILL_NUMBER_MAP = {
  3: [{ text: 'UAA' }],
  4: [{ text: 'RED' }],
  6: [{ text: 'UAC' }],
  7: [{ text: 'ESA' }],
  8: [{ text: 'ENA' }],
  9: [{ text: 'ESE' }],
  10: [{ text: 'SUE' }],
  12: [{ text: 'APC' }],
  13: [{ text: 'REF' }],
};

export { SKILL_NUMBER_MAP };
